<section id="content">

  <div class="page page-profile">

    <div class="pageheader">

      <h2>{{generalLang?.profile.profile | titlecase}}</h2>

      <div class="page-bar">

        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.PROFILE">{{generalLang?.profile.profile | titlecase}}</a>
          </li>
        </ul>

      </div>

    </div>

    <!-- page content -->
    <div class="pagecontent">


      <!-- row -->
      <div class="row">






        <!-- col -->
        <div class="col-md-3">

          <!-- tile -->
          <section class="tile tile-simple">

            <!-- tile widget -->
            <div class="tile-widget p-30 text-center">

              <div class="thumb thumb-xl">
                <img class="img-circle" [src]="generalData.profile_img" alt="">
              </div>
              <h4 class="mb-0"><strong>{{generalData.fname}}</strong></h4>
              <span class="text-muted">{{generalData.email}}</span>

            </div>
            <!-- /tile widget -->

          </section>
          <!-- /tile -->

        </div>
        <!-- /col -->

        <!-- col -->
        <div class="col-md-9">

          <!-- tile -->
          <section class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body p-0">

              <div role="tabpanel">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" class="active"><a href="#generalTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">{{generalLang?.profile.generalData | titlecase}}</a></li>
                  <li role="presentation" *ngxPermissionsOnly="['parentUser']"><a href="#settingsTab" aria-controls="settingsTab" role="tab"
                      data-toggle="tab">{{userLang?.user.heading | titlecase}}</a></li>
                </ul>

                <!-- Tab panes -->
                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane active" id="generalTab">

                    <div class="wrap-reset">

                      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
                        <div *ngFor="let validation of msg">
                          <div class="error-message"
                            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
                            {{validation.message}}
                          </div>
                        </div>
                      </ng-template>

                      <form [formGroup]="generalForm" (ngSubmit)="generalFormSubmit()" class="form-validation">

                        <div class="row">

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{generalLang?.profile.firstName | titlecase}}</label>
                            <input type="text" class="form-control" formControlName="fname"
                              [ngClass]="ErrorClass(generalForm.controls.fname, generalFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.fname, value:generalForm.controls.fname, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>

                          <div class="form-group col-sm-6">
                            <label for="last-name">{{generalLang?.profile.lastName | titlecase}}</label>
                            <input type="text" class="form-control" formControlName="lname"
                              [ngClass]="ErrorClass(generalForm.controls.lname, generalFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.lname, value:generalForm.controls.lname, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>

                        </div>

                        <div class="row">

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{generalLang?.profile.email | titlecase}}</label>
                            <input type="text" class="form-control" formControlName="email"
                              [ngClass]="ErrorClass(generalForm.controls.email, generalFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.email, value:generalForm.controls.email, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>

                          <div class="form-group col-sm-6">
                            <label for="last-name">{{generalLang?.profile.password | titlecase}}</label>
                            <input type="text" class="form-control" formControlName="password"
                              [ngClass]="ErrorClass(generalForm.controls.password, generalFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.password, value:generalForm.controls.password, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>

                        </div>

                        <div class="row">

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{generalLang?.profile.contactNo | titlecase}}</label>
                            <input type="text" class="form-control" formControlName="phone"
                              [ngClass]="ErrorClass(generalForm.controls.phone, generalFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.phone, value:generalForm.controls.phone, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>

                          <div class="form-group col-sm-6">
                            <label for="last-name">{{generalLang?.profile.company | titlecase}}</label>
                            <input type="text" class="form-control" formControlName="company"
                              [ngClass]="ErrorClass(generalForm.controls.company, generalFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.company, value:generalForm.controls.company, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>

                        </div>

                        <div class="row">

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{generalLang?.profile.vatNo | titlecase}}</label>
                            <input type="text" class="form-control" formControlName="vat"
                              [ngClass]="ErrorClass(generalForm.controls.vat, generalFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.vat, value:generalForm.controls.vat, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>

                          <div class="form-group col-sm-6">
                            <label for="last-name">{{generalLang?.profile.Headquarter | titlecase}}</label>
                            <input type="text" class="form-control" formControlName="hqo"
                              [ngClass]="ErrorClass(generalForm.controls.hqo, generalFormSubmitted)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.hqo, value:generalForm.controls.hqo, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>

                        </div>

                        <div class="row">

                          <div class="form-group col-sm-6">
                            <label for="first-name">{{generalLang?.profile.businessSize | titlecase}}</label>

                            <select class="form-control" formControlName="size"
                              [ngClass]="ErrorClass(generalForm.controls.size, generalFormSubmitted)">
                              <option [ngValue]="null" disabled>{{generalLang?.profile.businessSize0 | titlecase}}
                              </option>
                              <option *ngFor="let option of businessSizeValues" [ngValue]="option.value">{{option.text}}
                              </option>
                            </select>

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.size, value:generalForm.controls.size, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>

                          <div class="form-group col-sm-6">
                            <label for="avatar">{{generalLang?.profile.profileImage | titlecase}}</label>
                            <input type="file" class="filestyle"
                              [attr.data-text]="generalLang?.general.selectFile | titlecase" data-btnClass="btn-primary"
                              data-icon="<i class='fa fa-inbox mr-5'></i>" formControlName="profile"
                              [ngClass]="ErrorClass(generalForm.controls.profile, generalFormSubmitted)"
                              (change)="generalFormProfileChange($event)">

                            <ng-template [ngTemplateOutlet]="ErrorMsg"
                              [ngTemplateOutletContext]="{msg:generalFormMsg.profile, value:generalForm.controls.profile, submitted:generalFormSubmitted }">
                            </ng-template>

                          </div>
                          <input type="hidden" formControlName="profileImg">
                          <input type="hidden" formControlName="id">

                        </div>

                        <div class="row mt5">
                          <div class="col-md-12 text-center">
                            <button type="button" class="btn btn-warning mb-10" (click)="generalFormEdit()"
                              *ngIf="!generalFormApproved">{{generalLang?.general.edit | titlecase}}</button>
                            <button type="submit" class="btn btn-success mb-10"
                              *ngIf="generalFormApproved">{{generalLang?.general.update | titlecase}}</button>
                          </div>
                        </div>

                      </form>

                    </div>

                  </div>

                  <div role="tabpanel" class="tab-pane" id="settingsTab" *ngxPermissionsOnly="['parentUser']">

                    <div class="wrap-reset">

                      <div class="social-icons">
                        <a class="plus-export" data-toggle="modal" data-target="#userExportModal"
                          data-options="splash-2 splash-ef-4"> <span class="glyphicon glyphicon-export"></span> </a>

                        <a class="plus-add" (click)="userMangAction($event)" data-action="show" data-id="">
                          <i class="fa fa-plus"></i>
                        </a>
                        <a class="plus-delete" *ngIf="show_delete1" (click)="userMangAction($event)" data-action="multiDelete"
                          data-id="">
                          <span class="glyphicon glyphicon-trash"></span>
                        </a>
                      </div>

                      <table datatable [dtOptions]="dtOptions1" class="table-striped table-sm row-border hover"
                        id="user_table" (click)="catch_sort1()">
                        <thead>
                          <tr>
                            <th>Hidden.No</th>
                            <th>
                              <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input
                                  type="checkbox"><i></i></label>
                            </th>
                            <th>{{userLang?.user.sNo}}</th>
                            <th>{{userLang?.user.profile}}</th>
                            <th>{{userLang?.user.email}}</th>
                            <th>{{userLang?.user.firstName}}</th>
                            <th>{{userLang?.user.lastName}}</th>
                            <th>{{userLang?.user.actions}}</th>
                          </tr>
                        </thead>

                        <tbody>

                          <tr *ngFor="let user of userData; let i = index" id="{{user.id}}">
                            <td>{{i+1}}</td>
                            <td></td>
                            <td class="drag-cursor">{{i+1}}</td>
                            <td><img [src]="user.user_img" class="img-circle" style="width: 50px;height: 50px;"></td>
                            <td>{{user.email}}</td>
                            <td>{{user.fname}}</td>
                            <td>{{user.lname}}</td>
                            <td>
                              <div class="btn-group dropup">
                                <button type="button" class="btn btn-info dropdown-toggle circle_btn"
                                  data-toggle="dropdown" aria-expanded="false">
                                  <i class="fa fa-tasks"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-right action_btn" role="menu">
                                  <li><a (click)="userMangAction($event)" [attr.data-id]="user.id"
                                      data-action="show" class="edit_action">
                                      <i class="fa fa-edit"></i> {{userLang?.general.modify}}</a></li>
                                  <li><a (click)="userMangAction($event)" [attr.data-id]="user.id"
                                      data-action="delete" class="delete_action">
                                      <i class="fa fa-trash"></i> {{userLang?.general.delete}}</a></li>
                                </ul>
                              </div>
                            </td>
                          </tr>

                        </tbody>
                      </table>

                      <!-- <div class="radio-checked-card">
                        <label>
                          <input type="radio" name="test" value="small" checked>
                          <img src="http://localhost:8081/projects/kaizen/assets/images/flag1.png">
                          <span>Italian</span>
                        </label>

                        <label>
                          <input type="radio" name="test" value="big">
                          <img src="http://localhost:8081/projects/kaizen/assets/images/flag2.png"
                            style="width: 54px;height: 54px;">
                          <span>Italian</span></label>
                      </div> -->


                    </div>

                  </div>

                  </div>

              </div>

            </div>
            <!-- /tile body -->

          </section>
          <!-- /tile -->

        </div>
        <!-- /col -->











      </div>
      <!-- /row -->



    </div>
    <!-- /page content -->

  </div>

</section>

<button id="userModalBtn" class="btn btn-success mb-10" [style.display]="'none'" data-toggle="modal"
  data-target="#userModal" data-options="splash-2 splash-ef-4">Manage</button>

<div class="modal splash fade" id="userModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">

      <form [formGroup]="userForm" (ngSubmit)="userFormSubmit()" class="form-validation">

        <div class="modal-header">
          <h3 class="modal-title custom-font">{{userLang?.user.addUser}}</h3>
        </div>
        <div class="modal-body">

          <div class="row">

            <div class="form-group col-sm-6">
              <label>{{userLang?.user.email}}</label>
              <input type="text" class="form-control" formControlName="user_email"
                [ngClass]="ErrorClass(userForm.controls.user_email, userFormSubmitted)">

              <ng-template [ngTemplateOutlet]="ErrorMsg"
                [ngTemplateOutletContext]="{msg:userFormMsg.user_email, value:userForm.controls.user_email, submitted:userFormSubmitted }">
              </ng-template>

            </div>

            <div class="form-group col-sm-6">
              <label>{{userLang?.user.firstName}}</label>
              <input type="text" class="form-control" formControlName="user_fname"
                [ngClass]="ErrorClass(userForm.controls.user_fname, userFormSubmitted)">

              <ng-template [ngTemplateOutlet]="ErrorMsg"
                [ngTemplateOutletContext]="{msg:userFormMsg.user_fname, value:userForm.controls.user_fname, submitted:userFormSubmitted }">
              </ng-template>

            </div>

          </div>

          <div class="row">

            <div class="form-group col-sm-6">
              <label>{{userLang?.user.lastName}}</label>
              <input type="text" class="form-control" formControlName="user_lname"
                [ngClass]="ErrorClass(userForm.controls.user_lname, userFormSubmitted)">

              <ng-template [ngTemplateOutlet]="ErrorMsg"
                [ngTemplateOutletContext]="{msg:userFormMsg.user_lname, value:userForm.controls.user_lname, submitted:userFormSubmitted }">
              </ng-template>

            </div>

            <div class="form-group col-sm-6">
              <label>{{userLang?.user.password}}</label>
              <input type="text" class="form-control" formControlName="user_password"
                [ngClass]="ErrorClass(userForm.controls.user_password, userFormSubmitted)">

              <ng-template [ngTemplateOutlet]="ErrorMsg"
                [ngTemplateOutletContext]="{msg:userFormMsg.user_password, value:userForm.controls.user_password, submitted:userFormSubmitted }">
              </ng-template>

            </div>

          </div>

          <div class="row">

            <div class="form-group pro-width">
              <label for="avatar">{{userLang?.user.profileImage}}</label>
              <div class="profile-cmns">
                <div class="profile-bgs">
                  <img [src]="userForm.controls.user_profileImgDisp.value">
                </div>
                <div class="pro-input">
                  <input type="file" class="filestyle" data-btnClass="btn-primary"
                    [attr.data-text]="userLang?.general.selectFile" 
                    data-icon="<i class='fa fa-inbox mr-5'></i>" data-input="false" formControlName="user_profile"
                    (change)="userFormProfileChange($event)"
                    [ngClass]="ErrorClass(userForm.controls.user_profile, userFormSubmitted)">
                </div>
              </div>

              <ng-template [ngTemplateOutlet]="ErrorMsg"
                [ngTemplateOutletContext]="{msg:userFormMsg.user_profile, value:userForm.controls.user_profile, submitted:userFormSubmitted }">
              </ng-template>

            </div>

          </div>

          <table class="table read-checkbox">
            <thead>
              <tr>
                <th>{{userLang?.user.sections}}</th>
                <th>{{userLang?.user.readOnly}}</th>
                <th>{{userLang?.user.readWrite}}</th>
                <th>{{userLang?.user.deny}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngxPermissionsOnly="AppPermissions.DEADLINE">
                <td>{{userLang?.user.deadlines}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_deadline" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_deadline" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_deadline" value="0"><i></i>
                  </label>
                </td>
              </tr>
              <tr *ngxPermissionsOnly="AppPermissions.SERVICING">
                <td>{{userLang?.user.servicing}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_servicing" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_servicing" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_servicing" value="0"><i></i>
                  </label>
                </td>
              </tr>
              <tr *ngxPermissionsOnly="AppPermissions.HUMAN_RESOURCE">
                <td>{{userLang?.user.humanRes}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_human_res" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_human_res" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_human_res" value="0"><i></i>
                  </label>
                </td>
              </tr>
              <tr *ngxPermissionsOnly="AppPermissions.MEASUREMENT_TOOL">
                <td>{{userLang?.user.measTools}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_meas_tools" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_meas_tools" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_meas_tools" value="0"><i></i>
                  </label>
                </td>
              </tr>
              <tr *ngxPermissionsOnly="AppPermissions.PROBLEM_SOLVING">
                <td>{{userLang?.user.probSolv}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_problem_solv" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_problem_solv" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_problem_solv" value="0"><i></i>
                  </label>
                </td>
              </tr>


              <tr *ngxPermissionsOnly="AppPermissions.DOCUMENT_MANAGEMENT">
                <td>{{userLang?.user.docMang}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_doc_mang" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_doc_mang" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_doc_mang" value="0"><i></i>
                  </label>
                </td>
              </tr>
              <tr *ngxPermissionsOnly="AppPermissions.CUSTOMERS">
                <td>{{userLang?.user.customers}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_customers" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_customers" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_customers" value="0"><i></i>
                  </label>
                </td>
              </tr>
              <tr *ngxPermissionsOnly="AppPermissions.CONSULTANCY">
                <td>{{userLang?.user.consultancy}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_consultancy" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_consultancy" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_consultancy" value="0"><i></i>
                  </label>
                </td>
              </tr>
              <tr *ngxPermissionsOnly="AppPermissions.ACADEMY">
                <td>{{userLang?.user.academy}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_academy" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_academy" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_academy" value="0"><i></i>
                  </label>
                </td>
              </tr>
              <tr *ngxPermissionsOnly="AppPermissions.PROJECT">
                <td>{{userLang?.user.project}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_project" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_project" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_project" value="0"><i></i>
                  </label>
                </td>
              </tr>
              <tr *ngxPermissionsOnly="AppPermissions.AUDIT">
                <td>{{userLang?.user.audit}}</td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_audit" value="1"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_audit" value="2"><i></i>
                  </label>
                </td>
                <td>
                  <label class="remove_input">
                    <input type="radio" formControlName="user_audit" value="0"><i></i>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="modal-footer">
          <button class="btn btn-success">{{userLang?.general.submit}}</button>
          <button class="btn btn-warning" data-dismiss="modal">{{userLang?.general.close}}</button>
        </div>

      </form>

    </div>
  </div>
</div>

<div class="modal splash fade" id="userExportModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">


  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h3 class="modal-title custom-font">{{userLang?.general.selCol}}</h3>
      </div>
      <div class="modal-body column_export">

        <div class="row select-alls">
          <label class="checkbox checkbox-custom-alt checkbox-custom-sm"> <input type="checkbox"
              (change)="export1_select_deselect_all($event)"><i></i> {{userLang?.general.selectAll}} </label>
        </div>

        <div class="row flexs">
          <div class="active-left">
            <h2>{{userLang?.general.activeCol}}</h2>

            <div class="row" *ngFor="let option of dtCols1">
              <label class="checkbox checkbox-custom-alt checkbox-custom-sm">
                <input type="checkbox" value="{{option.id}}" [checked]="option.isSelected" class="col_select1"
                  (change)="export1_select_deselect($event)"><i></i> {{option.value}}
              </label>
            </div>

          </div>
        </div>

      </div>
      <div class="modal-footer">
        <div id="userExportModalAct" class="export_dynamic_btn">
        </div>
        <button class="btn btn-warning" data-dismiss="modal">{{userLang?.general.close}}</button>
      </div>
    </div>
  </div>
</div>